import { clsx } from "clsx";
import * as React from "react";
import styles from "./ShadowCard.module.css";

interface ShadowCardProps {
  className?: string;
  children: React.ReactNode;
  onClick?: VoidFunction;
}

const ShadowCard: React.FC<ShadowCardProps> = ({ children, className, ...props }) => {
  return (
    <div className={clsx(styles.card, className)} {...props}>
      {children}
    </div>
  );
};

export default ShadowCard;
